import { ADD_AMP_ANALYTICS } from './constants';

export const addAMPAnalytics = ampAnalyticsEvent => ({
  type: ADD_AMP_ANALYTICS,
  ampAnalyticsEvent,
});
